import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'srcReact/components/common2/Button'
import IconButton from 'srcReact/components/common2/IconButton'
import ListItem from 'srcReact/components/common2/ListItem'
import Spinner from 'srcReact/components/common2/Spinner'
import { TextArea } from 'srcReact/components/common2/TextArea'
import Icon from 'srcReact/components/icons/Icon'
import { urlSearchParams } from 'srcReact/helpers/utils'
import { isEmpty } from 'srcReact/helpers/validator'
import { moderationReportActions } from 'srcReact/ModerationReportPage'
import styles from './styles.module.scss'

function FlagReasons({ feed, entity, closeModal }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [selectedFlagReason, setSelectedFlagReason] = useState(null)
  const [additionalJustification, setAdditionalJustification] = useState({
    name: 'additionalJustification',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  })

  const {
    common: { isNative },
    organization: { current_organization },
    moderationReport: { flag_reasons, loading }
  } = useSelector((state) => state)

  const handleChangeAdditionalJustification = (e) => {
    const value = e.target.value
    setAdditionalJustification({
      ...additionalJustification,
      value: value,
      hasError: false,
      errorMessage: ''
    })
  }

  const handleSelectedFlagReason = (flagReason) => {
    const findSelectedFlagReason = flag_reasons.find((f) => f.reason === flagReason)
    setSelectedFlagReason(findSelectedFlagReason)
  }

  const handleBlur = () => {}

  const isValidatedFlag = (id_post, object_type, object_id, id_organization, id_flag_reason) => {
    if (id_post && object_type && object_id && id_organization && id_flag_reason) return true
    return false
  }

  const handleSubmitFlag = (e) => {
    e.preventDefault()
    if (isEmpty(additionalJustification.value)) {
      setAdditionalJustification({
        ...additionalJustification,
        hasError: true,
        errorMessage: t('moderationReport.flagPost.flagAdditionalRequired')
      })
      return false
    }
    let id_post = feed.id
    let object_type = (feed.relation && feed.relation.type) || (entity && entity.type) || ''
    let object_id = (feed.relation && feed.relation.id) || (entity && entity.id) || ''
    let id_organization = isNative
      ? urlSearchParams('organization_id')
      : current_organization && current_organization.info && current_organization.info.id
    let id_flag_reason = selectedFlagReason && selectedFlagReason.id
    let additional_justification = additionalJustification.value
    if (isValidatedFlag(id_post, object_type, object_id, id_organization, id_flag_reason)) {
      dispatch(
        moderationReportActions.addFlag(
          id_post,
          object_type,
          object_id,
          id_organization,
          id_flag_reason,
          additional_justification
        )
      )
      setTimeout(() => {
        closeModal()
      }, 500)
    }
  }

  return selectedFlagReason ? (
    <React.Fragment>
      <div className={styles.selectedFlagTitle}>
        <IconButton
          iconName='arrow-left24'
          iconSize='large24'
          className={styles.backButton}
          onClick={() => setSelectedFlagReason(null)}
        />
        <p>{selectedFlagReason.reason}</p>
      </div>
      <form className={styles.flagReasonForm}>
        <TextArea
          rows={8}
          isRequired={additionalJustification.isRequired}
          label={t('moderationReport.flagPost.label')}
          fieldInfo={additionalJustification}
          onChange={handleChangeAdditionalJustification}
          onBlur={handleBlur}
          customWrapperCss={styles.textboxFormWrapper}
          placeholder={t('moderationReport.flagPost.placeholder')}
        />
        <div className={styles.submitFlagReason}>
          <Button style='tertiary' size='large' text={t('global.cancel')} handleClick={closeModal} />
          <Button
            size='large'
            handleClick={handleSubmitFlag}
            text={loading ? <Spinner isWhite={true} /> : t('moderationReport.flagPost.sendReport')}
          />
        </div>
      </form>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <p className={styles.description}>{t('moderationReport.flagPost.description')}</p>
      <div className={styles.question}>{t('moderationReport.flagPost.question')}</div>
      <ListItem
        items={flag_reasons.map((f) => f.reason)}
        activeItem={'0'}
        className={styles.listClassName}
        itemClassName={styles.listItemClassName}
        setActiveItem={handleSelectedFlagReason}
        showIcon={true}
      />
    </React.Fragment>
  )
}

export default FlagReasons
